import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ClassificationItem } from '../type';

export interface ClassificationGroupService {
    handleDeleteItem: (listData: ClassificationItem[], target: string) => ClassificationItem[];
}

export const ClassificationGroupService = Symbol('ClassificationGroupService');

@injectable()
export class ClassificationGroupServiceImpl implements ClassificationGroupService {
    public handleDeleteItem(listData: ClassificationItem[], target: string): ClassificationItem[] {
        return listData.filter((item) => item.id !== target);
    }
}
